import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import TrendingVideos from './components/TrendingVideos';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <header>
        <Navbar />
      </header>
      <main>
        <HeroSection />
        <CategoryShowcase />
        <TrendingVideos />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteInfo.url}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            email: siteInfo.email,
            telephone: siteInfo.phone,
            address: {
              '@type': 'PostalAddress',
              addressCountry: 'CN',
              addressLocality: '北京',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${siteInfo.name} - 首页`,
            description: siteInfo.description,
            url: siteInfo.url,
            inLanguage: 'zh-CN',
            isPartOf: {
              '@type': 'WebSite',
              name: siteInfo.name,
              url: siteInfo.url,
            },
          }),
        }}
      />
    </>
  );
}